<template>
  <div class="separator" />
</template>

<script>
export default {
  name: 'appSeparator',
}
</script>

<style lang="scss" scoped>
.separator {
  width: 38px;
  height: 2px;
  background-color: #2acccc;
  margin: 0 auto;
}
</style>
